















































































































































import { Component, Vue } from "vue-property-decorator";
import Segment from '@/components/segment/index.vue';
import { ITbasList } from '@/common/models/index-app';
import { tabsListAStock, willListedConfig, listedConfig } from '../../common/config';
import StockListCard from '../../components/stockListCard/index.vue';
import StockListTable from '../../components/stockListTable/index.vue';
import { moduleType } from '../../common/constant';
import { getAStockBuyMessage, getAWillListedData, getAListedData, getServeDate } from '../../service/index';
import { aStockBuyMap, noDataConfigList } from './config/config';
import { handleBuyAllStock } from '../../../../common/client-agreement/hitNew';
import { getJumpToOrderNewStock, getUserBuyStockList, getOrderNewStockState, getBottomBtnStyle, clickBottomBtn } from '../../../../common/client-agreement/booking';
import { getClientBondSwitch, setClientBondSwitch } from '../../../../common/client-agreement/bondSwich';
import { showController, controllerUse } from '../../../../common/show-controller/index';
import Disclaimer from "../../../../components/disclaimer/index.vue";
import { getTabListAStock, getDefaultSelectedTabAStock, getDefaultTabIndexAStock, getBtnConfig, isJiaoYi, defaultModule } from '../../common/sourceConfig';
import { handlePageToThs } from '../../../../common/utils/utils';
import CommonQuestion from '../../components/CommonQuestion/index.vue'
const win: any = window;
const { hxmClickStat } = win;

@Component({
  components: {
    Segment,
    StockListCard,
    StockListTable,
    Disclaimer,
    CommonQuestion
  }
})
export default class AStockCalendar extends Vue {
  private tabsList: ITbasList[] = getTabListAStock();
  private dataNowStock: any = null; // 今日新股
  private dataWillBuyStock: any = null; // 即将申购
  private dataCheck: any = null; // 中签率
  private dataWillListedStock: any = null; // 待上市新股
  private dataWillListedBond: any = null; // 待上市新债
  private dataListed: any = null; // 上市表现
  private dataListedBond: any = null; // 上市表现
  private dataStock = null;
  private selectTab: any = tabsListAStock[getDefaultTabIndexAStock()];
  private tableConfig: any = willListedConfig;
  private show = true; // 是否显示新债
  private noDataConfigCardList = noDataConfigList;
  private dataBuy: any = []; // 申购数据
  private limit = 20; // 每页请求多少数据
  private page = 1; // 当前分页
  private pageBond = 1; // 当前分页
  private pageData: any = {}; // 总的分页配置
  private pageDataBond: any = {}; // 总的分页配置
  private loading = false; // 是否在加载数据
  private listedType = 'stock'; // 当前选中的是新股还是新债
  private isShowButton = true; // 是否显示打新按钮
  private isDisabled = false; // 是否禁用button
  private date: any = null; // 时间
  private isSharePadding: any = !win.F10Utils.getBroker() && win.F10Utils.getUrlParams('fromshare');
  private count: any = 0; // tab组件被点击了多少次
  private isJiaoYi = isJiaoYi; // 是否在交易申购中
  private sourceBtn: any = getBtnConfig(); // 不同来源的按钮配置
  private defaultTabName = getDefaultSelectedTabAStock();
  private hasReadAgreement: boolean = false;
  private showRiskTips = false;

  private buttonConfig = {
    name: '一键申购',
    styleType: 1,
    account: () => {
      this.buyAllStockFn();
    }
  }

  private async created() {
    if (win.getAccount()) {
      // 如果已登录，从缓存获取是否同意
      this.getLocalStorage();
    }
    // 页面首次请求的模块类型：非交易时为 today_order，交易时为wait_order
    const reqModuleType = defaultModule();
    this.date = await getServeDate();
    const data = await this.getStockListData(reqModuleType);

    // 位于交易申购页面时，通过客户端协议获取按钮状态&加载tab下的数据
    if(this.isJiaoYi){
      this.dataWillBuyStock = this.handleDataByDate(data, moduleType.WAITORDER, true);
      this.getButtonStyleInJiaoyi();
    }else{
      this.dataStock = data;
    }

    this.isShowButton = this.getIsShowButton(this.selectTab.name)
    // 通过协议获取当前是否打开了新债开关
    getClientBondSwitch((res: boolean) => {
      this.show = res;
      this.dataNowStock =  this.handleDataByDate(data, moduleType.ORDER, this.show);
      this.isDisabled = this.getButtonStat(this.dataNowStock, this.selectTab.name)
      this.buttonConfig = this.getButtonConfig(this.show, this.dataNowStock);
    })
    // 获取当前用户申购了哪些股票
    getUserBuyStockList((data: any)=>{
      this.dataBuy = data && data.data ? data.data : [];
    })
  }
  private async mounted() {
    this.handleOnShow();
    const data = await this.getStockListData({module: moduleType.SUCCESS})
    this.dataCheck =  this.handleDataByDate(data, moduleType.SUCCESS, true);
    document.addEventListener("scroll", this.handleLoadMoreData, false);
    if (this.isSharePadding) {
      document.getElementsByClassName('closeNavBtn')[0].addEventListener('click', ()=>{
        this.isSharePadding = false;
      })
    }
  }

  // 触发onshow方法处理 onshow在从二级页面或者其他地方回到页面时触发
  private handleOnShow() {
    win.registerWebListener('onShow', () => {
      if (this.isJiaoYi){
        this.getButtonStyleInJiaoyi();
      }

      if (this.selectTab.name === 'willBuy') {
        this.handleOrder();
      }
      if (this.selectTab.name === 'todayBuy') {
      // 通过协议获取当前是否打开了新债开关
      getClientBondSwitch((res: boolean) => {
          if(this.show === res) {
            return;
          }
          this.show = res;
          this.dataNowStock =  this.handleDataByDate(this.dataStock, moduleType.ORDER, this.show);
          this.isDisabled = this.getButtonStat(this.dataNowStock, this.selectTab.name)
          this.buttonConfig = this.getButtonConfig(this.show, this.dataNowStock);
        })
      }
    });
  }

  private beforeDestroy() {
    document.removeEventListener("scroll", this.handleLoadMoreData, false);
  }
  /**
   * 处理加载更多上市表现数据
   */
  private async handleLoadMoreData() {
    if (this.selectTab.name === 'listedPerformance') {
      const top =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      const height = document.body.clientHeight;
      const scrollHeight = document.body.scrollHeight;
      let page = 0;
      let pageData:any = {};
      if (this.listedType === 'stock') {
        page = this.page;
        pageData = this.pageData;
      } else {
        page = this.pageBond;
        pageData = this.pageDataBond;
      }
      if (
        top + height > scrollHeight - 182 && !this.loading && pageData &&
        page < pageData.count
      ) {
        this.loading = true;
        const data = await this.getListedData(moduleType.LISTEDPERFORMANCE, { page: page + 1, limit: this.limit, type: this.listedType });
        let resData: any = null;
        if (this.listedType === 'stock') {
          this.page = this.page + 1;
          resData = JSON.parse(JSON.stringify(this.dataListed));
        } else {
          this.pageBond = this.pageBond + 1;
          resData = JSON.parse(JSON.stringify(this.dataListedBond));
        }

        if (data && data.stock && data.stock.listData && data.stock.listData.length > 0) {
          resData.stock.titleData.dataList = [...resData.stock.titleData.dataList, ...data.stock.titleData.dataList]
          resData.stock.listData = resData.stock.listData.map((item: any, index: number)=>{
            item.dataList = [...item.dataList, ...data.stock.listData[index].dataList];
            return item;
          })
        }
        if (data && data.bond && data.bond.listData && data.bond.listData.length > 0) {
          resData.bond.titleData.dataList = [...resData.bond.titleData.dataList, ...data.bond.titleData.dataList]
          resData.bond.listData = resData.bond.listData.map((item: any, index: number)=>{
            item.dataList = [...item.dataList, ...data.bond.listData[index].dataList];
            return item;
          })
        }

        if (this.listedType === 'stock') {
          this.dataListed = resData;
        } else {
          this.dataListedBond = resData;
        }
        this.loading = false;
      }
    }
  }

  private getJumpToOrderNewStock(){
    const errorCodeCanJump = (data: any) =>  (String(data.errorCode) === '5' || String(data.errorCode) === '2');

    getJumpToOrderNewStock((data: any) => {
      if (errorCodeCanJump(data)) {
        win.F10Utils.jumpToLink(
          {
            url: `//data.10jqka.com.cn/datacenterph/ipo/booking.html?qsId=${data.qsid}&qsName=${data.qsname}&resCode=${data.errorCode}`,
          }
        )
      } 
    })
  }

  /**
   * 处理预约 
   */
  private handleOrder() {
    if (!win.F10Utils.getBroker() && win.F10Utils.getUrlParams('fromshare')) {
      this.$nextTick(()=>{
        this.buttonConfig = {
          name: '一键预约',
          styleType: 1,
          account: () => {
            hxmClickStat(this.selectTab.maidian + '.yysg')
            this.getJumpToOrderNewStock();
          }
        }
      });
      return;
    }

    // 交易中使用了新的客户端协议控制底部按钮，此处就不需要调用原有的协议，避免冲突
    if(this.isJiaoYi){
      return;
    }

    getOrderNewStockState((data: any) => {
      if (String(data.errorCode) !== '0') {
        this.$nextTick(()=>{
          this.buttonConfig = {
            name: '一键预约',
            styleType: 1,
            account: () => {
              hxmClickStat(this.selectTab.maidian + '.yysg')
              this.getJumpToOrderNewStock();
            }
          }
        })
        return;
      }

      this.$nextTick(()=>{
        this.buttonConfig = {
          name: '查看预约',
          styleType: 2,
          account: () => {
            hxmClickStat(this.selectTab.maidian + '.ckyy')
            this.getJumpToOrderNewStock();
          }
        }
      })
    })
  }

  private async getDataByTabItem(item: any){
    const getDataValue = (data:any,key:string,defaultValue:any) => {
      if(data && data[key]){
        return data[key]
      }
      return defaultValue;
    }
    // 待申购
    if (item.name === 'willBuy') {
      // 处理预约逻辑
      this.handleOrder();
      if (!this.dataWillBuyStock) {
        const data = await this.getStockListData({module: moduleType.WAITORDER})
        this.dataWillBuyStock =  this.handleDataByDate(data, moduleType.WAITORDER, true);
      }
      this.isDisabled = this.getButtonStat(this.dataWillBuyStock, item.name)
    }
    // 可申购
    if (item.name === 'todayBuy') {
      // 获取当前用户申购了哪些股票
      getUserBuyStockList((data: any)=>{
        this.dataBuy = getDataValue(data,'data',[]);
      })
      if (!this.dataNowStock) {
        const data = await this.getStockListData({module: moduleType.ORDER});
        this.dataNowStock =  this.handleDataByDate(data, moduleType.ORDER, this.show);
      }
      this.buttonConfig = this.getButtonConfig(this.show, this.dataNowStock);
      this.isDisabled = this.getButtonStat(this.dataNowStock, item.name)
    }
    // 待上市
    if (item.name === 'willPerformance') {
      this.$nextTick(()=>{
        this.buttonConfig = {
          name: '',
          styleType: 1,
          account: () => {return;}
        }
      })
      this.tableConfig = willListedConfig;
      if (!this.dataWillListedStock) {
        const dataWillListed = await getAWillListedData();
        this.dataWillListedStock = dataWillListed;
      }
    }
    // 已上市
    if (item.name === 'listedPerformance') {
      this.$nextTick(()=>{
        this.buttonConfig = {
          name: '',
          styleType: 1,
          account: () => {return;}
        }
      })
      this.tableConfig = listedConfig;
      if (!this.dataListed) {
        const data = await this.getListedData(moduleType.LISTEDPERFORMANCE, { page: this.page, limit: this.limit, type: this.listedType });
        this.dataListed = data;
        this.pageData = getDataValue(data,'page',{});
      }
    }
  }

  /**
   * 处理tab切换
   */
  private async handleChange(item: any) {
    this.count = this.count + 1;
    const nowCount = this.count;
    // 页面返回顶部
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.isShowButton = this.getIsShowButton(item.name);
    this.listedType = 'stock';
    this.loading = true;

    await this.getDataByTabItem(item);

    this.loading = false;
    if (nowCount === this.count) {
      this.selectTab = this.tabsList[item.index];
    }

    hxmClickStat(this.selectTab.maidian, {});

  }


  private async getStockListData(type: any) {
    const data: any = await getAStockBuyMessage(type);
    return data;
  }

  /**
   * 将数据按照年份处理
   */
  private handleDataByDate(data: any, type: string, show?: boolean) {
    const dateObj: any = {}
    const stockLen = data && data.stock && data.stock.length > 0 ? data.stock.length : 0;
    const bondLen = data && data.bond && data.bond.length > 0 ? data.bond.length: 0;
    if (stockLen) {
      data.stock.forEach((item: any) => {
        const date = type === moduleType.SUCCESS ? item.successDate : item.orderDate;
        if (!dateObj[date]) {
          dateObj[date] = []
        }
        dateObj[date].push(item)
      });
    }
    if (bondLen && show) {
      data.bond.forEach((item: any) => {
        const date = type === moduleType.SUCCESS ? item.successDate : item.orderDate;
        if (!dateObj[date]) {
          dateObj[date] = []
        }
        dateObj[date].push(item)
      });
    }
    return this.getListDate(dateObj, type);
  }

  /**
   * 将按照年份处理完的对象变成数组的形式
   */
  private getListDate(data: any, type: string) {
    const resData = [];
    for(const key in data) {
      const dataObj: any = {
        config: {
          date: key,
          ...aStockBuyMap[type]
        },
        data: data[key]
      }
      resData.push(dataObj);
    }
    return resData
  }

  /**
   * 获取待上市数据
   */
  private async getWillListedData() {
    const data: any = await getAWillListedData();
    return data;
  }

  /**
   * 获取上市表现数据
   */
  private async getListedData(type: string, params: any) {
    const data: any = await getAListedData(type, params);
    return data;
  }

  /**
   * 处理显示新债单选框
   */
  private handleChangeRadio(show: boolean) {
    this.show = show;
    // 设置客户端新债开关
    setClientBondSwitch(show);
    this.dataNowStock =  this.handleDataByDate(this.dataStock, moduleType.ORDER, show);
    this.isDisabled = this.getButtonStat(this.dataNowStock, this.selectTab.name);
    this.$nextTick(()=>{
      this.buttonConfig = this.getButtonConfig(show, this.dataNowStock)
    })
  }

  /**
   * 获取按钮显示文案及点击协议
   */
  private getButtonConfig(show: boolean, data: any) {
    if (!data || data.length === 0) {
      return {
        name: '暂无新股申购',
        styleType: 1,
        account: () => {
          return;
        }
      }
    }
    if (!this.isBuyTime()) {
      return {
        name: this.getNotBuyText(this.date && this.date.timestamp),
        extra: '申购时间: 09:30~15:00',
        styleType: 1,
        account: () => {
          return;
        }
      }
    }
    return {
      name: '一键申购',
      styleType: 1,
      account: () => {
        this.buyAllStockFn();
      }
    }
  }

  /**
   * 点击按钮调用协议
   */
  private handlebutton(e: any, account: Function, flag: boolean) {
    if (flag) {
      e.preventDefault();
    } else {
      account();
    }
  }

  /**
   * 点击按钮调用协议(交易申购)
   */
  private handleSourceButton() {
    clickBottomBtn(this.sourceBtn.btnStyle);
  }

  /**
   * 新股新债tab切换处理
   */
  private async handleChangeType(type: string, tabName: string) {
    let data: any = {};
    this.loading = true;
    if (tabName === 'ssbx') {
      if (type === 'stock' && !this.dataListed) {
        data = await this.getListedData(moduleType.LISTEDPERFORMANCE, { page: this.page, limit: this.limit, type });
        this.dataListed = data;
        this.pageData = data && data.page ? data.page : {};
      }
      if (type === 'bond' && !this.dataListedBond) {
        data = await this.getListedData(moduleType.LISTEDPERFORMANCE, { page: this.pageBond, limit: this.limit, type });
        this.dataListedBond = data;
        this.pageDataBond = data && data.page ? data.page : {};
      }
      this.listedType = type;
    }
    if (tabName === 'dss') {
      if (type === 'stock' && !this.dataWillListedStock) {
        this.dataWillListedStock = await getAWillListedData()
      }
      if (type === 'bond' && !this.dataWillListedStock) {
        this.dataWillListedStock = await getAWillListedData();
      }
      this.dataWillListedStock = {...this.dataWillListedStock}
    }
    this.loading = false;
  }

  /**
   * 获取当前页面是否支持打新以及预约
   */
  private getIsShowButton(nowTab: string) {
    // 有协议的页面或者分享出去的页面显示按钮
    if (nowTab === 'willBuy') {
      return showController('hitNewStock') || (!win.F10Utils.getBroker() && win.F10Utils.getUrlParams('fromshare'));
    }

    if (nowTab === 'todayBuy') {
      return controllerUse('hitNewStock') || win.F10Utils.getUrlParams('fromshare');
    }
    return true;
  }

  /**
   * 获取当前页面是否支持打新以及预约
   */
  private getButtonStat(data: any, nowTab: string) {
    if (!data || data.length === 0) {
      return true;
    }
    if(!this.isBuyTime() && nowTab !== 'willBuy') {
      return true;
    }
    return false;
  }

  /**
   * 调用客户端协议获取底部按钮样式
   */
  private getButtonStyleInJiaoyi(){
    getBottomBtnStyle((res: any)=>{
      const style = Number(res.btnStyle);
      this.sourceBtn.btnStyle = style;
      if(style === 1) {
        this.sourceBtn.btnText = '一键预约';
      }
      if(style === 2) {
        this.sourceBtn.btnText = '查看预约';
      }
    });
  }

  private getNotBuyText(time: string) {
    const date = new Date(Number(time) * 1000);
    const hour = date.getHours() < 10 ? `0${date.getHours()}` : `${date.getHours()}`
    const min = date.getMinutes() < 10 ? `0${date.getMinutes()}` : `${date.getMinutes()}`
    const clock = `${hour}:${min}`
    if (clock <= '09:29' && clock >= '00:00') {
      return '申购未开始';
    }
    if (clock >= '15:00' && clock <= '23:59') {
      return '申购结束';
    }
    return '申购结束';
  }

  /**
   * 当前是否可以购买
   */
  private isBuyTime() {
    if(
      (this.date && this.date.stat === '交易中') || 
      (this.date && this.date.stat === '午间休市')
    ) {
      return true;
    }
    return false;
  }

  /**
   * 登录
   */
  private goLogin(sucFn: Function, param: boolean) {
    win.F10Utils.jumpToLogin();
    let timer: any = null;
    timer = setInterval(async () => {
      if (win.getAccount()) {
        sucFn(param);
        clearInterval(timer);
      }
    }, 200);
  }

  /**
   * 切换是否已阅读风险提示
   */
  private changeRadioStatus() {
    if (this.isSharePadding) {
      handlePageToThs();
      return;
    }
    if (!win.getAccount()) {
      this.goLogin(this.setLocalStorage, true);
    } else {
      const statText = this.hasReadAgreement ? '.disagree' : '.agree';
      hxmClickStat(this.selectTab.maidian + statText);
      this.setLocalStorage(!this.hasReadAgreement);
    }
  }

  // 从本地获取同意状态
  private getLocalStorage() {
    if (win.getAccount) {
      this.hasReadAgreement = localStorage.getItem(`data-center-ph-agree-protocol-${win.getUserid()}`) === '1';
    }
  }

  // 保存状态并修改变量
  private setLocalStorage(val: boolean) {
    this.hasReadAgreement = val;
    localStorage.setItem(`data-center-ph-agree-protocol-${win.getUserid()}`, val ? '1' : '0');
  }

  // 同意协议
  private agreeRiskTips() {
    hxmClickStat(this.selectTab.maidian + '.dialog.agree');
    this.setLocalStorage(true);
    this.buyAllStock();
    this.closeRiskTips(false);
  }

  /**
   * 关闭弹窗
   */
  private closeRiskTips(needStat = true) {
    needStat && hxmClickStat(this.selectTab.maidian + '.dialog.quxiao');
    this.showRiskTips = false;
  }

  /**
   * 打开弹窗
   */
  private showRiskTipsFn() {
    hxmClickStat(this.selectTab.maidian + '.dialog.show');
    this.showRiskTips = true;
  }

  /**
   * jumpRisk
   */
  private jumpRisk(statText = '.riskwarning') {
    hxmClickStat(this.selectTab.maidian + statText);
    const url = "//mams.10jqka.com.cn/new/server/html/49851.html";
    win.F10Utils.jumpToLink({url});
  }

  // 一键申购
  private buyAllStockFn() {
    if (this.isSharePadding) {
        handlePageToThs();
        return;
    }
    if (!win.getAccount()) {
      this.goLogin(this.buyAllStock, false);
      return;
    }
    this.buyAllStock();
  }

  // 一键申购
  private buyAllStock() {
    if (!this.hasReadAgreement) {
      this.showRiskTipsFn();
      return;
    }
    hxmClickStat(this.selectTab.maidian + '.yjsg');
    handleBuyAllStock(this.show, (code: string) => {
      // 用户申购完成后获取下用户申购成功了哪些股票
      if (String(code) === '1') {
        getUserBuyStockList((data: any)=>{
          this.dataBuy = data.data;
        })
      }
    });
  }
}
